import { TIMELINE, type TimelineEvent } from '@/pages/home/data';

const marker: Record<TimelineEvent['tone'], string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-foreground-950',
};

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.5fr] lg:gap-16">
          {/* intro rail */}
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
              <span className="inline-block h-px w-8 bg-primary-500" />
              04 · 事件脉络
            </div>
            <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              网红翻车现场
              <br />
              按周捋清脉络
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一场塌房从发酵到反转，往往只要一周。时间线把来龙去脉按日归档，
              再散的瓜，也能顺着时间轴一次吃透。
            </p>

            <div className="mt-8 space-y-3 border-l border-background-300 pl-5">
              {[
                ['发酵', '片段流出 → 评论区考古'],
                ['实锤', '同框逐帧 / 截图对拍'],
                ['回应', '声明 → 争议再起'],
              ].map(([s, d]) => (
                <div key={s} className="flex items-center gap-3">
                  <span className="inline-flex h-6 items-center whitespace-nowrap rounded-sm bg-secondary-100 px-2 text-[11px] font-semibold text-secondary-900">
                    {s}
                  </span>
                  <span className="text-sm text-foreground-600">{d}</span>
                </div>
              ))}
            </div>
          </div>

          {/* timeline list */}
          <div className="relative">
            <span className="absolute left-[52px] top-1 bottom-1 w-px bg-background-300 md:left-[68px]" />
            <div className="space-y-6">
              {TIMELINE.map((ev) => {
                const m = marker[ev.tone];
                return (
                  <div key={ev.date} className="relative flex items-center gap-4 md:gap-6">
                    {/* date chip */}
                    <div
                      className={`z-10 flex h-[52px] w-[52px] shrink-0 flex-col items-center justify-center rounded-md ${m} md:h-[68px] md:w-[68px]`}
                    >
                      <span className="font-heading text-xl font-black leading-none md:text-2xl">
                        {ev.date}
                      </span>
                      <span className="mt-0.5 text-[10px] opacity-80">{ev.weekday}</span>
                    </div>

                    {/* card */}
                    <a
                      href="#bundle"
                      className="group min-w-0 flex-1 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-all hover:border-primary-300 md:p-5"
                    >
                      <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
                        {ev.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{ev.body}</p>
                      <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                        查看事件详情
                        <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                      </span>
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}